import React from 'react';
import ReactDOM from 'react-dom/client';
// Token layer first, so `body` in index.css and the MUI theme can both
// reference --itc-font-* without depending on CRA's CSS bundling order.
import './theme/tokens.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme/muiTheme';
// ITCurves design system faces: Google Sans (page + modal titles, avatar
// monograms, body and all UI) and Google Sans Code (versions).
// See src/theme/tokens.css.
//
// Import the `latin-` entrypoints, never the bare `400.css`. Google Sans ships
// 25 unicode subsets (Bengali, Devanagari, Khmer, Tamil, ...) and the bare
// entrypoint pulls every one: 544 KB per weight against 24 KB for latin alone.
import '@fontsource/google-sans/latin-400.css';
import '@fontsource/google-sans/latin-500.css';
import '@fontsource/google-sans/latin-600.css';
import '@fontsource/google-sans/latin-700.css';
import '@fontsource/google-sans-code/latin-400.css';
import '@fontsource/google-sans-code/latin-500.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
